import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { PRODUCT_CONTEXTS, type ProductContext } from '@atlassian/assets-workspace-host/constants';

export const getProductContext = (tenantContext: TenantContext): ProductContext | undefined => {
	const appPermissions = tenantContext.appPermissions ?? {};
	// Jira Software access (with or without JSM) resolves to the Jira product context.
	if (appPermissions.hasSoftwareAccess) {
		return PRODUCT_CONTEXTS.JIRA;
	}
	if (appPermissions.hasServiceDeskAccess) {
		return PRODUCT_CONTEXTS.JSM;
	}
};

export const workspaceUtils = {};
